import React from 'react';

export const ToggleSwitch = React.memo(
  ({ className = '', keyId, type = '', checked, disabled = false, onChange }) => {
    return (
      <div className={'mc-toggle-switch ' + type + ' ' + className}>
        <div className={'button r'}>
          <input
            type='checkbox'
            className='checkbox'
            checked={!!checked}
            disabled={disabled}
            onChange={onChange}
            name={keyId}
          />
          <div className='knobs' />
          <div className='layer' />
        </div>
      </div>
    );
  }
);
ToggleSwitch.displayName = 'ToggleSwitch';
